var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.4 13.6V8.8H9.6V13.6H13.6V7.2H16L8 0L0 7.2H2.4V13.6H6.4Z","fill":"#969EB0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }